import { useEffect, useState } from "react";
import {
  getMapOffers,
  MapOffersSchema,
} from "src/models/productMapOffers/getMapOffers";
import { useRouter } from "next/router";
import { FilterModalCheckbox } from "src/components/ReservationProduct/components/FiltersModal/FiltersModal";
import { toastAlert } from "src/components/common/SnackbarAlert/toastAlert";

export const useMapOffers = (
  productSlug: string,
  filtersData: FilterModalCheckbox
) => {
  const [data, setData] = useState<MapOffersSchema[]>();
  const [isLoading, setLoading] = useState<boolean>(false);
  const [currentPageSize, setCurrentPageSize] = useState<number>(20);
  const [placemarkReady, setPlacemarkReady] = useState(true);

  const handlePlacemarkLoad = () => {
    setPlacemarkReady(true);
  };

  const handleShowMore = () => {
    setCurrentPageSize((prevState) => prevState + 20);
  };

  const {
    query: { city },
  } = useRouter();

  useEffect(() => {
    if (typeof city === "string") {
      setCurrentPageSize(20);
      setLoading(true);
      setData([]);
      setPlacemarkReady(false);
      getMapOffers({
        isDayAndNight: filtersData.aroundTheClock,
        isFutureBooking: filtersData.underTheOrder,
        isTodayBooking: filtersData.available,
        product_slug: productSlug,
        city_slug: city,
      })
        .then((res) => {
          setData(res.data);
          if (res.data.length === 0) {
            setPlacemarkReady(true);
            toastAlert(
              "По заданным фильтрам ничего не найдено. Пожалуйста, измените фильтры.",
              "error",
              {
                autoClose: 6000,
              }
            );
          }
        })
        .catch((error) => error)
        .finally(() => {
          setLoading(false);
        });
    }
  }, [city, filtersData, productSlug]);

  return {
    dataMapOffers: data,
    handleShowMore,
    isLoading,
    currentPageSize,
    handlePlacemarkLoad,
    placemarkReady,
  };
};
